import { Toolbar } from 'components/List'
import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ListProps,
} from 'react-admin'

import { FilterApp } from 'components/FilterApp'

export const ListPersons: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      {...rest}
      actions={
        <Toolbar>
          <FilterApp filterPerson filterCourse={false} filterLesson={false} filterUser={false}/>
        </Toolbar>
      }
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Nome" source="title" />
        <TextField label="Tipo" source="type" />
        <TextField label="Slug" source="slug" />
        <TextField label="Subtítulo" source="subtitle" />
        <TextField label="Curriculum" source="resume" />
        <TextField label="Bio" source="biography" />
      </Datagrid>
    </List>
  )
}
